export default function File() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="file">
                <path
                    id="Icon"
                    d="M11.6654 1.89127V5.33338C11.6654 5.80009 11.6654 6.03345 11.7562 6.21171C11.8361 6.36851 11.9636 6.49599 12.1204 6.57589C12.2986 6.66672 12.532 6.66672 12.9987 6.66672H16.4408M11.6654 14.1667H6.66536M13.332 10.8333H6.66536M16.6654 8.32351V14.3333C16.6654 15.7335 16.6654 16.4335 16.3929 16.9683C16.1532 17.4387 15.7707 17.8212 15.3003 18.0608C14.7656 18.3333 14.0655 18.3333 12.6654 18.3333H7.33203C5.9319 18.3333 5.23183 18.3333 4.69705 18.0608C4.22665 17.8212 3.8442 17.4387 3.60451 16.9683C3.33203 16.4335 3.33203 15.7335 3.33203 14.3333V5.66666C3.33203 4.26653 3.33203 3.56646 3.60451 3.03168C3.8442 2.56128 4.22665 2.17882 4.69705 1.93914C5.23183 1.66666 5.9319 1.66666 7.33203 1.66666H10.0085C10.62 1.66666 10.9257 1.66666 11.2134 1.73573C11.4685 1.79697 11.7124 1.89798 11.9361 2.03506C12.1884 2.18966 12.4046 2.40585 12.8369 2.83823L15.4938 5.49508C15.9262 5.92746 16.1424 6.14365 16.297 6.39594C16.434 6.61963 16.535 6.86349 16.5963 7.11858C16.6654 7.4063 16.6654 7.71203 16.6654 8.32351Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}
